package com.kaihuoy.home.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.shared.data.User
import com.kaihuoy.components.common.*
import com.kaihuoy.web.WebFirebaseRepository
import com.kaihuoy.components.common.*

@Composable
fun AddUserScreen(onBack: () -> Unit) {
    var email by remember { mutableStateOf("") }
    var displayName by remember { mutableStateOf("") }
    var isAdmin by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf<String?>(null) }

    val repository = remember { WebFirebaseRepository() }

    Div(attrs = { style { padding(32.px, screenContentPadding()); maxWidth(600.px); margin(0.px) } }) {
        H1 { Text("Lisää uusi käyttäjä") }

        StyledInput(
            label = "Koko nimi",
            value = displayName,
            onValueChange = { displayName = it }
        )

        StyledInput(
            label = "Sähköposti",
            value = email,
            onValueChange = { email = it }
        )

        StyledCheckbox(
            label = "Anna ylläpitäjän oikeudet (Admin)",
            checked = isAdmin,
            onCheckedChange = { isAdmin = it }
        )

        message?.let {
            P(attrs = {
                style {
                    color(if (it.contains("onnistui")) KaihuTheme.Green else KaihuTheme.Danger)
                    margin(16.px, 0.px)
                }
            }) {
                Text(it)
            }
        }

        Div(attrs = { style { display(DisplayStyle.Flex); gap(16.px); marginTop(24.px) } }) {
            StyledButton(
                text = if (isLoading) "Lisätään..." else "Lisää käyttäjä",
                onClick = {
                    if (email.isBlank() || displayName.isBlank()) {
                        message = "Nimi ja sähköposti ovat pakollisia"
                        return@StyledButton
                    }

                    isLoading = true
                    message = null

                    repository.createUserAndSendInvitation(
                        email = email.trim(),
                        displayName = displayName.trim(),
                        isAdmin = isAdmin
                    ) { success, errorMsg ->
                        isLoading = false
                        if (success) {
                            message = "Käyttäjä lisätty onnistuneesti! Kutsu lähetettiin sähköpostiin."
                            // Tyhjennetään kentät
                            email = ""
                            displayName = ""
                            isAdmin = false
                        } else {
                            message = errorMsg ?: "Lisäys epäonnistui"
                        }
                    }
                },
                enabled = !isLoading
            )

            StyledButton(
                text = "Peruuta",
                onClick = onBack,
                backgroundColor = KaihuTheme.Grey
            )
        }
    }
}